///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.alerts = abcsetup.alerts || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.alerts.callback = null;
abcsetup.alerts.force = false;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    $('#alerts-modal,#confirm-modal,#prompt-modal').on('shown.bs.modal', () => abcsetup.unblockUI());

    $('#alerts-modal').on('hide.bs.modal', function () {
        if (abcsetup.alerts.callback) {
            abcsetup.alerts.callback();
        }
    }).on('shown.bs.modal', function () {
        $(this).find('.btn-secondary').trigger('focus');
    });

    $('#confirm-modal').on('hide.bs.modal', function () {
        if (abcsetup.alerts.callback) {
            abcsetup.alerts.callback($('#confirm-modal').data('resp'));
        }
    });

    $(document).on('click', '#confirm-modal .btn-primary', function () {
        $('#confirm-modal').data('resp', true).modal('hide');
    });

    $('#confirm-modal').on('shown.bs.modal', function () {
        $(this).data('resp', false);
        $(this).find('.btn-primary').trigger('focus');
    });

    $('#prompt-modal').on('shown.bs.modal', function () {
        $(this).data('resp', false);
        const input = $(this).find(':visible:input.form-control').focus();
        input.get(0).setSelectionRange(input.val().length, input.val().length);
    });

    $('#prompt-modal').on('hide.bs.modal', function () {
        if (abcsetup.alerts.callback) {
            abcsetup.alerts.callback([
                $('#prompt-modal').data('resp'),
                $(this).find('input').val() || $(this).find('textarea').val(),
            ]);
        }
    });

    $(document).on('click', '#prompt-modal .btn-primary', function () {
        // Force the prompt form
        const inputField = $('#prompt-modal input,#prompt-modal textarea');
        if (abcsetup.alerts.force && !inputField.val()) {
            inputField.addClass('invalid');
            return;
        }

        $('#prompt-modal').data('resp', true).modal('hide');
    });

    // We have form errors - show a popup
    if ($('#messages-container').length) {
        /*
        var errors = {};
        errors.message = $('#messages-container').find('.form-errors').html();
        if (errors.message) {
            abcsetup.alerts.showErrors(errors);
        }
        */

        if (!abcsetup.guest) {
            let hideAlertTimeoutID = null;
            $(document).on('DOMNodeInserted', () => {
                if ($('#messages-container .alert:visible').length > 0 && !hideAlertTimeoutID) {
                    hideAlertTimeoutID = window.setTimeout(() => {
                        $('#messages-container .alert').fadeOut('slow');
                        hideAlertTimeoutID = null;
                    }, 5000);
                }
            });
        }
    }
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.alerts = {
    /**
     *
     * @param {*} title
     * @param {*} body
     * @param {*} callback
     */
    show: function (title, body, callback = null, options = {}) {
        $('#alerts-modal .modal-title').html(title);
        $('#alerts-modal .modal-body').html(body);

        abcsetup.alerts.callback = callback;

        $('#alerts-modal').modal(options);
        $('#alerts-modal').modal('show');
    },

    hide: function () {
        $('#alerts-modal').modal('hide');
    },


    /**
     *
     * @param {*} title
     * @param {*} body
     * @param {*} callback
     * @param {*} confirm_button_text
     */
    confirm: function (title, body, callback = null, confirm_button_text = null, confirm_button_class = null) {
        const ConfirmModal = $('#confirm-modal');
        ConfirmModal.data('resp', false);
        ConfirmModal.find('.modal-title').html(title);
        ConfirmModal.find('.modal-body').html(body);
        if (confirm_button_text) {
            ConfirmModal.find('.btn.confirm').text(confirm_button_text)
        }
        if (confirm_button_class) {
            //ConfirmModal.find('.btn.confirm').removeClass('btn-primary').addClass(confirm_button_class);
            ConfirmModal.find('.btn.confirm').addClass(confirm_button_class);
        } else {
            ConfirmModal.find('.btn.confirm').attr('class', 'btn btn-primary confirm');
        }
        abcsetup.alerts.callback = callback;

        ConfirmModal.modal('show');
    },


    /**
     *
     * @param {string} title
     * @param {string} body
     * @param {*} callback
     * @param {boolean} force Force a response; make it required.
     * @param {boolean} numeric Do we want a numeric value from the user?
     * @param {boolean} textarea Should we use a textarea input? (might be best to use an inputType param which can be something like "numeric", "textarea" and default to "text")
     * @param {string} defaultValue The default value for the input field.
     */
    prompt: function (title, body, callback = null, force = false, numeric = false, {
        textarea = false,
        defaultValue = ''
    } = {}) {
        const Modal = $('#prompt-modal');
        const ModalBody = Modal.find('.modal-body');

        Modal.data('resp', false);
        Modal.find('.modal-title').html(title);
        ModalBody.html(body);

        abcsetup.alerts.callback = callback;
        abcsetup.alerts.force = force;

        if (numeric) {
            ModalBody.append(`<input type="text" class="form-control mt-2 numeric" value="${defaultValue}">`);
        } else if (textarea) {
            ModalBody.append(`<textarea class="form-control mt-2">${defaultValue}</textarea>`);
        } else {
            ModalBody.append(`<input type="text" class="form-control mt-2" value="${defaultValue}">`);
        }

        Modal.modal('show');

        window.fieldValidate.init();
    },


    /**
     *
     * @param {*} errors
     * @param {*} callback
     */
    showErrors: function (errors, callback = null) {
        //alert(JSON.stringify(errors));
        let addedItems = false;
        let message = 'You have errors with your submission. Please check the data you entered and try again.';

        if (errors && errors.message) {
            message = errors.message;
        }

        if (errors && errors.errors) {
            for (var i in errors.errors) {
                // Laravel turns array fields into a dot syntax: 'items[1][id]' => 'items.1.id'.
                // Assuming we'll not use a dot for a legit field name, assuming any dots in a field name from the server are that and making this a selector jQuery can use.
                const fieldName = String(i).split('.').map((fieldNameComponentFromServer, index) => {
                    if (index === 0) {
                        return fieldNameComponentFromServer;
                    }

                    return `\\\\[${fieldNameComponentFromServer}\\\\]`;
                }).join('');

                console.log(`[name='${fieldName}']`)
                $(`[name='${fieldName}']`).addClass('is-invalid');

                if (errors.errors[i]) {
                    if (!addedItems) {
                        message = '<b>Whoops!</b> There were some problems with your submission:';
                        message = message + '<br><ul class="submission-errors">';
                        addedItems = true;
                    }

                    message = message + '<li>' + errors.errors[i] + '</li>';
                }
            }
        }

        if (addedItems) {
            message = message + '</ul>';
        }

        // Remove the is-invalid class when the errored field is updated or changed
        $(document).off('change.formError, keyup.formError', '.is-invalid').on('change.formError, keyup.formError', '.is-invalid', function (e) {
            $(this).removeClass('is-invalid');
        });

        this.show('Submission Errors', message, callback);
    },

    flashMessage(message, type = 'success', w_scroll = true) {
        var icon = type == 'success' ? '<i class="fas fa-check-circle mr-1"></i>' : '<i class="fas fa-exclamation-circle"></i>';
        var extra_class = 'position-fixed mt-5';
        if (w_scroll) {
            extra_class = 'mt-4';
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        }

        $('#messages-container .alerts-container').append(`
        <div class="alert alert-${type} ${extra_class}">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            ${icon}
            ${message}
        </div>
        `);
    },
}
